import { InputOnChangeData, Textarea, TextareaProps } from "@fluentui/react-components";
import React, { useCallback } from "react";
import { TFieldWrapperComponentProps } from "./WithFormFieldWrapper.types";
import { WithFormFieldWrapper } from "./WithFormFieldWrapper";

import { observer } from "mobx-react";

export type IM365PulseFormTextareaFieldProps = TFieldWrapperComponentProps<Omit<TextareaProps, "value" | "defaultValue" | "onChange">>;

const M365PulseFormTextareaFieldBase = (props: IM365PulseFormTextareaFieldProps) => {
    const {
        formikFieldProps: {
            field: { value },
            form: { setFieldValue }
        },
        name,
        ...restProps
    } = props;

    const onChange = useCallback(
        (ev: React.ChangeEvent<HTMLTextAreaElement>, data: InputOnChangeData) => setFieldValue(name, data.value),
        [name, setFieldValue]
    );

    return <Textarea value={value} onChange={onChange} {...restProps} />;
};

export const M365PulseFormTextareaField = observer(WithFormFieldWrapper(M365PulseFormTextareaFieldBase));
